import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-free-trial-two',
  templateUrl: './free-trial-two.component.html',
  styleUrls: ['./free-trial-two.component.scss']
})
export class FreeTrialTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
